// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-18931dfd{to{stroke-dashoffset:0}}.value-container[data-v-18931dfd]{display:flex;gap:10px}.value-container .discount-value[data-v-18931dfd]{color:#ffba4e}.value-container .original-value[data-v-18931dfd]{color:#6b6b6b;font-weight:400;-webkit-text-decoration:line-through;text-decoration:line-through;word-break:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
